export const StatusFilter = [
    { status: 'Inventory', value: 'Inventory' },
    { status: 'Inventory Requests', value: 'Pending' },
];

export const InventoryHeader = [
    { id: 'checkbox', label: '', minWidth: 50, align: 'center' },
    { id: 'product', label: 'Product Details', minWidth: 170, align: 'center' },
    // { id: 'title', label: 'Product Details', minWidth: 170, align:'center' },
    { id: 'model', label: 'Model', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'brand', label: 'Brand', minWidth: 120, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'lowest_price', label: 'Lowest Online Price', minWidth: 120, align: 'center' },
    { id: 'price', label: 'Unit Price', minWidth: 120, align: 'center' },
    // { id: 'active', label: 'Status', minWidth: 200, align:'center'},
    { id: 'action', label: 'Activate/Inactivate Product', minWidth: 200, align: 'center' },
];

export const AcceptedRequestHeader = [
    { id: 'requestedDate', label: 'Requested Date', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'brand', label: 'Brand', minWidth: 120, align: 'center' },
    { id: 'acceptedModel', label: 'Accepted Model', minWidth: 170, align: 'center' },
    { id: 'requestedModel', label: 'Requested Model', minWidth: 170, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'price', label: 'Unit Price', minWidth: 120, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 120, align: 'center' },
];

export const InventoryRequestHeader = [
    { id: 'requestedDate', label: 'Requested Date', minWidth: 170, align: 'center' },
    { id: 'category', label: 'Category', minWidth: 170, align: 'center' },
    { id: 'brand', label: 'Brand', minWidth: 120, align: 'center' },
    { id: 'requestedModel', label: 'Requested Model', minWidth: 170, align: 'center' },
    { id: 'quantity', label: 'Quantity', minWidth: 120, align: 'center' },
    { id: 'price', label: 'Unit Price', minWidth: 120, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 120, align: 'center' },
];

export const ProdStatus = [
    { label: 'Active', value: '1' },
    { label: 'Inactive', value: '0' }
];

export const CatalogueRequestStatus = [
    { label: 'WIP', value: 'WIP' },
    { label: 'Accepted', value: 'ACCEPTED' },
    { label: 'Rejected', value: 'REJECTED' },
    // { label: 'Instant Live', value: 'INSTANT_LIVE' }
]

export const Category = [
    { label: 'Air Conditioners', value: 'air-conditioner' },
    { label: 'Washing Machines', value: 'Washing-machine' },
    { label: 'Televisions', value: 'televisions' },
    { label: 'Refrigerators', value: 'Refrigerator' },
    { label: 'Mobiles', value: 'Mobiles' },
    { label: 'Kitchen Appliances', value: 'Kitchen Appliances' },
    { label: 'Small Appliances', value: 'Small Appliances' },
    { label: 'Audio', value: 'Audio' },
    { label: 'Personal Care', value: 'Personal Care' },
    { label: 'IT', value: 'IT' },
];

export const PageItems = [
    15,
    25,
    50
]
